import React, { useState } from "react";

import { useFormikContext } from "formik";

import { Box, Divider, Flex, Grid, GridItem, Text } from "@chakra-ui/react";

import { Group } from "../../Group";
import { CustomInputWField } from "../../../../../components/CustomInputWField";
import CustomDropzone from "../../../../../components/CustomDropzone";
import { RadioOptions } from "../../RadioOptions";
import { cpf } from "../../../../../utils/masks";
import FileInformation from "../../../../../components/FileInformation";

export const PossuiCPF = ({
  anexoEditado,
  setAnexoEditado,
  invalidCPF,
  acolhedorValid,
  message,
  idAnexo,
  idTipoPendencia,
  scrollToField,
}) => {
  const { setFieldValue, values, errors, touched } = useFormikContext();
  const [isFocused, setIsFocused] = useState(false);
  const [isBlur, setIsBlur] = useState(false);

  return (
    <Group
      border={
        idAnexo === "4" || ["16", "17", "18"].includes(idTipoPendencia)
          ? "3px solid #4299E199"
          : ""
      }
      scrollToField={
        idAnexo === "4" || ["16", "17", "18"].includes(idTipoPendencia)
          ? scrollToField
          : null
      }
    >
      <Text
        mt="5"
        mb="2"
        fontWeight={700}
        fontSize="16px"
        lineHeight="21.6px"
        color="#169499"
      >
        CPF
      </Text>
      <Divider mb="5" />
      <RadioOptions
        label="Possui CPF?*"
        fieldName="possuiCpf"
        errors={errors}
        touched={touched}
      />
      <Grid mt="15px" templateColumns="repeat(5, 1fr)" gap="25px" rowGap="20px">
        {values.possuiCpf === "S" && (
          <GridItem colSpan={{ base: 2, sm: 2, lg: 2 }}>
            <CustomInputWField
              fieldName="cpf"
              label="Número do CPF*"
              placeholder="000.000.000-00"
              maxLength={14}
              onChange={(e) => setFieldValue("cpf", cpf(e.target.value))}
              setIsFocused={setIsFocused}
              setIsBlur={
                values?.cpf?.replace(/[^\d]+/g, "").length === 11 && setIsBlur
              }
            />
            {!errors.cpf &&
              values.cpf &&
              !isFocused &&
              !invalidCPF &&
              !isBlur && (
                <Text color="red" opacity={0.8} mt={2} fontSize="12px">
                  Informar um CPF válido
                </Text>
              )}
            {!errors.cpf &&
              values.cpf &&
              !isFocused &&
              acolhedorValid &&
              invalidCPF &&
              !isBlur && (
                <Text color="red" opacity={0.8} mt={2} fontSize="12px">
                  {message ? message : ""}
                </Text>
              )}
          </GridItem>
        )}
      </Grid>
      <Grid
        display={"flex"}
        flexDirection={{ base: "column", lg: "row" }}
        mt="25px"
        templateColumns="repeat(4, 1fr) 1fr"
        gap="25px"
      >
        {values.possuiCpf === "S" && (
          <GridItem colSpan={{ base: 2, sm: 2, lg: 1 }}>
            {anexoEditado || !values.originalAnexoCpf ? (
              <Flex>
                <CustomDropzone
                  whiteSpace={true}
                  formProps={{ setFieldValue }}
                  title="Anexar CPF"
                  fieldName="anexoCpf"
                  setAnexoNaoEditado={
                    values.originalAnexoCpf
                      ? () => {
                          setAnexoEditado(false);
                        }
                      : null
                  }
                  height="42px"
                  width={"216px"}
                />
              </Flex>
            ) : (
              values.originalAnexoCpf && (
                <FileInformation
                  label="Anexar CPF"
                  name={values.originalAnexoCpf.nomeArquivo}
                  path={values.originalAnexoCpf.path
                    .toString()
                    .split("/")
                    .pop()}
                  setAnexoEditado={() => {
                    setAnexoEditado(true);
                  }}
                  isVisualizacao={false}
                  height="42px"
                  width={"216px"}
                />
              )
            )}
          </GridItem>
        )}
        <GridItem colSpan={{ base: 2, sm: 2, lg: 2 }}>
          <Box width={{ lg: "450.48px" }}>
            <CustomInputWField
              fieldName="numeroSolicitacaoCPF"
              label="Número de solicitação do documento ao órgão responsável"
              placeholder="Informe o Número de Solicitação"
              whiteSpace={true}
            />
          </Box>
        </GridItem>
      </Grid>
    </Group>
  );
};
